import angular from 'angular';

var module = angular.module('app.bedford-list', []);

export default module;
